// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-83f982fa] .p-panel-title {\n  text-align: center !important;\n}\n[data-v-83f982fa] .p-panel-content {\n  padding: 0.2rem !important;\n}\n[data-v-83f982fa] .p-panel.p-panel-toggleable .p-panel-header {\n  padding: 0.1rem 1rem !important;\n}\n[data-v-83f982fa] .p-tabview .p-tabview-panels {\n  padding: 0rem;\n}\n[data-v-83f982fa] .p-tabview-nav-link {\n  padding: 0.5rem !important;\n}", ""]);
// Exports
module.exports = exports;
